import traverseAndParseErrorJson from "./traverseAndParseErrorJson";
/**
 * rawFieldsErrorsJson  might look like:
 ```json
[
  {
    "fields": {
      "name": "setting.some.error.locale.key",  // string case
      "address": [  // array case
        "setting.foo.error.locale.key",
        "setting.bar.message.locale.key",
      ],
    }
  },
  {
    "fields": {
      "group": {  // subfiled case
        "_error": "setting.some.error.locale.key",
      },
      "tel": "\{"key":"setting.some.error.locale.key","params":{"foo":"foo"}}"  // JSON case
    }
  },
  ...
]
 ```

 return
 ```json
  {
    "name": ["setting.some.error.locale.key"],  // string case
    "address": [  // array case
      "setting.foo.error.locale.key",
      "setting.bar.message.locale.key",
    ],
    "group": {  // subfiled case
      "_error": ["setting.some.error.locale.key"],
    },
    "tel": [{"key":"setting.some.error.locale.key","params":{"foo":"foo"}]  // JSON case
  }
 ```
 */
const transformToFieldErrorsMap = (rawFieldsErrorsJson = []) => rawFieldsErrorsJson.reduce((fieldsErrors, rawFieldsErrorJson) => {
  if (rawFieldsErrorJson.fields) {
    return {
      ...fieldsErrors,
      ...traverseAndParseErrorJson(rawFieldsErrorJson.fields)
    };
  }
  return fieldsErrors;
}, {});
export default transformToFieldErrorsMap;